import { render } from "./Voluntary.vue?vue&type=template&id=288691e9"
import script from "./Voluntary.vue?vue&type=script&lang=ts"
export * from "./Voluntary.vue?vue&type=script&lang=ts"

import "./Voluntary.vue?vue&type=style&index=0&id=288691e9&lang=scss"
script.render = render

export default script